import { render, staticRenderFns } from "./SourceMain.vue?vue&type=template&id=864ea4f2&scoped=true"
import script from "./SourceMain.vue?vue&type=script&lang=ts"
export * from "./SourceMain.vue?vue&type=script&lang=ts"
import style0 from "./SourceMain.vue?vue&type=style&index=0&id=864ea4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864ea4f2",
  null
  
)

export default component.exports